import * as React from 'react';
import { WithNamespaces, withNamespaces } from 'react-i18next';

const NotAllowedRaw: React.SFC<WithNamespaces> = ({ t }) => {
  return (
    <>
      <h2>{t('error.403.error')}</h2>
      <h5>{t('error.403.suberror')}</h5>
    </>
  )
}

export const NotAllowed = withNamespaces()(NotAllowedRaw)
